<ng-container *ngIf="product">
  <a [routerLink]="product.routerLink ? product.routerLink : { cxRoute: 'product', params: product } | cxUrl"
    [queryParams]="{gaListName: gaListName, entry_source: gaEntrySource}" (click)="selectItem(product)" class="cx-product-image-container"
    [class.disabled-link]="isSubs" tabindex="-1">
    <cx-media class="cx-product-image"
      *ngIf="(product.servicePart && product.images?.PRIMARY) || !product.servicePart; else spGearThumb"
      [container]="product.images?.PRIMARY" [class.sub-non-image]="isSubs && !product.images?.PRIMARY.product"
      format="product" [alt]="product.name || product.summary"></cx-media>
    <ng-template #spGearThumb>
      <img src="../../../../../../assets/icons/sp_gear_thumb.svg" alt="gear" class="sp-gear-thumb">
    </ng-template>
  </a>
  <a *ngIf="!isSubs"
    [routerLink]="product.routerLink ? product.routerLink : ({ cxRoute: 'product', params: product } | cxUrl)"
    [queryParams]="{gaListName: gaListName, entry_source: gaEntrySource}" (click)="selectItem(product)" class="cx-product-name"
    [innerHTML]="product.name" title="{{product.name}}"></a>

  <a *ngIf="isSubs" class="cx-product-name" [innerHTML]="product.name"></a>

  <span *ngIf="isSubs" class="summary" [innerHTML]="product.summary"></span>

  <ng-template [cxOutlet]="ProductListOutlets.ITEM_DETAILS">
    <div class="cx-product-price-container">
      <ng-container *ngIf="product.purchasable || isSubs || product?.purchaseLabel; else nonPurchasable">
        <div class="cx-product-price" [attr.aria-label]="'productDetails.productPrice' | cxTranslate"
          [class.mb-0]="product.bundleAvailable">
          {{ product.price?.formattedValue }}
          <ng-container *ngIf="!isSubs">
            <span class="price-label" *ngIf="product.price?.formattedValue">{{ product.servicePart ? 'MSLP' : 'MSRP'}}</span>
            <gen-info-price-wrapper [product]="product" [position]="TooltipPosition.Right"></gen-info-price-wrapper>
          </ng-container>
        </div>
        <a *ngIf="!isSubs && product.bundleAvailable"
          [routerLink]="{ cxRoute: 'bundles', params: { productCode: product.code, name: product.slug } } | cxUrl"
          class="buy-in-bundle link cx-action-btn-link">
          Buy In Bundle >
        </a>
      </ng-container>

      <ng-template #nonPurchasable>
        <div class="cx-product-price"
          *ngIf="!product.purchasable && !isSubs && product?.servicePart && !product?.unavailabilityDetail"
          [attr.aria-label]="'productDetails.productPrice' | cxTranslate">
          {{ product.price?.formattedValue }}
          <span class="price-label">{{ product.servicePart ? 'MSLP' : 'MSRP'}}</span>
          <gen-info-price-wrapper [product]="product" [position]="TooltipPosition.Right"></gen-info-price-wrapper>
        </div>
      </ng-template>

      <gen-product-badge *ngIf="product?.badges?.length" [badges]="product.badges" [size]="'small'"></gen-product-badge>
   
      <div class="contact-us" *ngIf="!product.purchasable && !product?.servicePart && !product.purchaseLabel && product?.erpStatus !== 'DISCONTINUED'">
          Please contact us for pricing details.
      </div>
    </div>
     
  </ng-template>

  <gen-add-to-cart *ngIf="product?.purchasable || product.purchaseLabel" [product]="product" [purchasable]="true" [productCode]="product.code"
    [showQuantity]="false" [gaListName]="gaListName" [gaEntrySource]="gaEntrySource" [gaProductCategories]="gaProductCategories" [isSubs]="isSubs"
    [isAddModal]="isAddModal" (onAddModalAdded)="onAddModalAdded.emit($event)"></gen-add-to-cart>

  <div *ngIf="!product.purchasable && !product.purchaseLabel" class="no-add-to-cart">
    <gen-add-to-favorites [product]="product" [gaListName]="gaListName"
      [gaProductCategories]="gaProductCategories"></gen-add-to-favorites>
  
    <gen-sp-icons [product]="product"></gen-sp-icons>
    
    <div class="position-relative non-price-status tooltip-container"
      (mouseenter)="callForPricingMessage=tooltipMessage" (mouseleave)="callForPricingMessage=''"
      [class.service-parts]="product?.servicePart"
      [class.align-flex-end]="product?.unavailabilityDetail?.type === GenUnavailabilityDetailType.ContactFactoryNotForIndividualSale">
      <ng-container *ngIf="product?.servicePart; else regularProduct;">
        <div
          *ngIf="product?.unavailabilityDetail?.type === GenUnavailabilityDetailType.ContactFactory 
          || product?.unavailabilityDetail?.type === GenUnavailabilityDetailType.ContactFactoryNotForIndividualSale; else plainText;"
          class="contact-factory-block">
          <span *ngIf="product?.unavailabilityDetail?.description" class="unavailability-detail-description">
            {{product?.unavailabilityDetail?.description}}
          </span>
          <a class="call-for-pricing link cx-action-btn-link" (click)="openContactFactory()">
            {{product?.unavailabilityDetail?.label}}
          </a>
        </div>

        <gen-info-price-wrapper *ngIf="product?.unavailabilityDetail" [product]="product"
          [position]="TooltipPosition.Right"></gen-info-price-wrapper>

        <gen-product-purchase-restriction-message *ngIf="!product?.unavailabilityDetail"
          [purchaseRestricted]="product?.purchaseRestrictedByScopeRules" [messageType]="'tool-tip'"
          [areaOfImplement]="'product-carousels'">
        </gen-product-purchase-restriction-message>

        <ng-template #plainText>
          <span class="call-for-pricing">{{product?.unavailabilityDetail?.label}}</span>
        </ng-template>
      </ng-container>

      <ng-template #regularProduct>
        <div *ngIf="!product.purchaseLabel" class="position-relative" (mouseenter)="callForPricingMessage=tooltipMessage"
          (mouseleave)="callForPricingMessage=''">
          <a [href]="contactForPricingHref" class="call-for-pricing link cx-action-btn-link">
            Contact For Pricing
            <gen-info-message [message]="callForPricingMessage" [position]="'position-right'"></gen-info-message>
          </a>
        </div>
      </ng-template>

    </div>
  </div>

  <div *ngIf="isServicePartsEnabled && product?.materialNotes && product?.servicePart"
    [ngClass]="{'note-expanded': !showMoreNotes}" class="sp-note-container">
    <span>
      <strong>Note: </strong>
      <span class="sp-note" [innerHTML]="(product?.materialNotes + ' '  || '') | safe"></span>
    </span>
    <span class="dots" *ngIf="materialNotesLength >= 68 && showMoreNotes">
      ...
    </span>
    <button class="more-less" *ngIf="materialNotesLength >= 68" (click)="toggleMoreLessNotes()">
      {{showMoreNotes ? 'more' : 'less'}}
    </button>
  </div>

</ng-container>